<template>

    <div>
      <el-button type="text" size="normal"   @click="back">返回</el-button>
    <div class="flex" style="float: right;" >
        <el-row class="demo-autocomplete">
            <el-col :span="30">
                <el-autocomplete
                class="inline-input"
                v-model="state1"
                :fetch-suggestions="querySearch"
                placeholder="请输入搜索的文档名称  "
                :trigger-on-focus="false"
                @select="handleSelect"
                style="margin:10px;"
                ></el-autocomplete>
                        <el-date-picker
                        v-model="value2"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                        </el-date-picker>
                <el-button  type="primary" icon="el-icon-search" @click="gecDocByCondition(state1,value2)" style="margin:10px;">搜索</el-button>
                <el-button  type="primary" icon="el-icon-plus" @click="uploadFile">上传文档</el-button>
            </el-col>
         </el-row>
        </div><br> 
            
        <div class="mt10" >
            <el-table :data="docsAll" style="width: 100%"   :row-style="{height:'50px'}"
                :cell-style="{padding:'0px'}">
                <el-table-column prop="id" label="文档ID"  ></el-table-column>
                <el-table-column prop="document_name" label="文档名称"></el-table-column>
                <el-table-column prop="create_time" label="创建时间" ></el-table-column>
                <el-table-column label="文档管理" width="180" fixed="right">
                  <template slot-scope="scope" >
                      <el-button type="primary" @click="downLoad(scope.row)"><a :href=link  style='color:white;text-decoration:none' >下载</a></el-button>
                      <el-button type="danger" @click="deleteDoc(scope.row)">删除</el-button>
                  </template>
              </el-table-column>
            </el-table>
        </div><br>


        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%" >
            <div >
                <el-upload
                    :headers="myHeaders"
                    :limit="1"
                    :data="myData"
                    :on-success="handleUploadSuccess"
                    ref="upload"
                    drag
                    action="https://jianzao.genyun2019.cn/admin/project/uploadFile"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </div>
        </el-dialog> 


        <div class="block"  align = "center" >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[10,20,50]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="this.docs.length">
          </el-pagination>
         </div>
      </div>
    
</template>
<script>


export default {
    data() {
        return {
             pageNo:1,
             pageSize:10,
             pickerOptions: {
             shortcuts: [{
            text: '最近一周',

            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
            data:{
                create_time:"",
              },
            value2: '',
            docsAll: [],
            docs: [],
            state1: '',
            link:"",
            myHeaders: {
                        token: this.$api.request_body.token
                    },
             myData: {
                projectId: this.$route.params.id
             },
            dialogVisible:false,
            downloadVisible:false,
            id:null,
            doc: {
            document_name: "",
            create_time: "",
            document_link:"",
            if_deleted:""
        },
            formLabelWidth: "100px",
            activeName: "first",
            form: {
                name: null,
                builders: []
            },
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.getDocByProjectId();
    },
    methods: {
      back() {
      this.$router.back();
      },
        handleSelect(item) {
    },
    querySearch(queryString, cb) {
        let arr = [];
        this.docs.forEach((item, index) => {
            let obj = new Object();
            obj.value = item.document_name
            arr.push(obj)
        })
        var list = arr;
        var results = queryString ? list.filter(this.createFilter(queryString)) : list;
        // 调用 callback 返回建议列表的数据
          cb(results);
    },


    createFilter(queryString) {
      return (list) => {
        return (list.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
        // 上传成功回调
    handleUploadSuccess(res, file) {
        if(res.err == 1){
            this.$message.error(res.message);
        }else{
            this.$message.success(res.message);
        }
        this.pageSize = 10   
        this.getDocByProjectId();
        this.dialogVisible = false;
        this.$refs.upload.clearFiles()
    },
  
    handleSizeChange(val) {
      this.pageSize=val
      this.docsAll = this.docs.slice((this.pageNo-1) * this.pageSize,this.pageSize* this.pageNo)
       for(let data of this.docsAll){
                  while(data.create_time.includes("T")){
                        data.create_time = data.create_time.replace("T"," ")
                  }
              }
    },
    handleCurrentChange(val) {
      this.pageNo=val
      this.docsAll = this.docs.slice((this.pageNo-1) * this.pageSize,this.pageSize* this.pageNo)
       for(let data of this.docsAll){
                  while(data.create_time.includes("T")){
                        data.create_time = data.create_time.replace("T"," ")
                  }
              }
    },
      async getDocByProjectId() {
        let rs = await this.$api.getDocByProjectId(this.id)
        this.docs = rs.data
        this.docsAll = rs.data
         for(let data of this.docsAll){
                  while(data.create_time.includes("T")){
                        data.create_time = data.create_time.replace("T"," ")
                  }
              }
    },
    async gecDocByCondition(name,value2) {
        this.pageNo = 1
        this.PageSize = 10
      if(value2 == null){
          this.getDocByProjectId()
      }
      var  date1  = new Date(value2[0])
      var begin=date1.getFullYear() + '-' +
          (date1.getMonth() + 1) + '-' + 
          date1.getDate() + ' ' + 
          date1.getHours() + ':' + 
          date1.getMinutes() + ':' + 
          date1.getSeconds()
      var  date2  = new Date(value2[1])
      var end=date2.getFullYear() + '-' +
          (date2.getMonth() + 1) + '-' + 
          date2.getDate() + ' ' + 
          date2.getHours() + ':' + 
          date2.getMinutes() + ':' + 
          date2.getSeconds()
          
      let rs = await this.$api.gecDocByCondition(name,begin,end,this.id)
      this.docs = rs.data
      this.handleSizeChange(this.pageSize)
      this.handleCurrentChange(this.pageNo)
      if(this.docs.length == 0 ){
            this.$message('当前条件下不存在文档！');
          this.getDocByProjectId()
      }
   },
    async downLoad(item) {
     this.link = item.document_link
  },
    async uploadFile() {
      this.dialogVisible =true
  },
    async getProject() {
        let rs = await this.$api.project(this.id);
        if (rs.err == 0) {
            rs.data.builders = [];
            this.form = rs.data;
            this.getProjectBuilders();
        }
    },
    async getOrganizes() {
        let rs = await this.$api.getOrganizes();
        if (rs.err == 0) {
            this.organizes = rs.data;
        }
    },
    async getProjectBuilders() {
        let rs = await this.$api.getProjectBuilders(this.id);
        if (rs.err == 0) {
            this.form.builders = rs.data;
        }
    },
    async deleteDoc(item) {
      let rs = await this.$api.deleteDoc(item.id,item.document_link);
      if(rs.err == 0){
        this.$message.success("删除成功！");
        this.getDocByProjectId();
      }
      this.pageSize = 10
  },
    async save() {
        let rs = await this.$api.updateProjectSetting(this.id, this.form.name, this.form.builders);
        if (rs.err == 0) {
            this.$notify({
                message: "保存成功"
            })
       }
    }
  }
}
</script>
<style lang="less" scoped>
</style>